(function () {

  'use strict';

  function pxDestinationEmail($timeout, $window, RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '=',
        emailFormModel: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/email/destinationEmail.template.html',
      link: function (scope, element, attrs) {

        scope.BAD_FILE_NAME = new RegexModel().badNameString_variables().string;
        scope.BAD_EMAIL_STRING = new RegexModel().badEmailString_variables().string;
        scope.selectPlaceHolder = 'Select';

        scope.focusString = function (textboxRef, badEmail) {
          const element = angular.element('#' + textboxRef);
          const string = element[0].value;
          const start = string.indexOf(badEmail);
          const end = start + (badEmail.length + 1);
          element[0].focus();
          element[0].setSelectionRange(start, end);
        };

        scope.focusText = function (textboxRef) {
          $timeout(() => {
            const element = angular.element('#' + textboxRef);
            element[0].focus();
          }, 50);
        };

        scope.resizeTextarea = function ($event, textboxRef, target) {
          const illegalCharRegexCheck = new RegexModel().illegalChars();
          if (scope.workflowFormModel.destination === 'SEND_TO_EMAIL') {
            if (illegalCharRegexCheck.test(scope.emailFormModel.emailString[target])) {
              scope.emailFormModel.emailSetupIsInvalid = true;
              scope.workflowForm[textboxRef.toLowerCase()].$invalid = true;
            } else {
              $timeout(() => {
                const element = angular.element('#' + textboxRef);
                const text = document.createElement('div');
                text.style.overflowWrap = 'break-word;';
                text.style.zIndex = 100000000000;
                text.style.padding = '6px 10px 5px 10px';
                text.style.width = element[0].offsetWidth + 'px';
                text.style.top = '-50%';
                text.style.left = '-50%';
                text.classList.add('op0', 'absolute', 'yellowgreen');
                text.innerHTML = element[0].value;
                document.body.appendChild(text);
                let clientHeight = text.clientHeight;
                if (clientHeight < 35) {
                  clientHeight = 35;
                }
                element[0].style.height = clientHeight + 'px';
                text.remove();
                scope.emailFormModel.update(target);
                if (scope.emailFormModel.unVerifiedEmailRecipients.length > 0) {
                  scope.emailFormModel.findUnVerifiedEmailRecipients();
                }
              }, 50);
            }
            for (const key in scope.emailFormModel.emailString) {
              if (illegalCharRegexCheck.test(scope.emailFormModel.emailString[key])) {
                scope.emailFormModel.emailSetupIsInvalid = true;
                scope.workflowForm.$invalid = true;
              }
            }
          }
        };

        function reportWindowSize() {
          if (scope.workflowFormModel.SEND_TO_EMAIL) {
            scope.resizeTextarea(null, 'EMAIL_TO', 'to');
            if (scope.emailFormModel.show.cc) {
              scope.resizeTextarea(null, 'EMAIL_CC', 'cc');
            }
            if (scope.emailFormModel.show.bcc) {
              scope.resizeTextarea(null, 'EMAIL_BCC', 'bcc');
            }
          }
          scope.$apply();
        }

        $window.onresize = reportWindowSize;

        scope.$on('$destroy', function () {
          $window.onresize = null;
        });

      }
    };
  }

  pxDestinationEmail.$inject = ['$timeout', '$window', 'RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxDestinationEmail', pxDestinationEmail);

})();
